<template>
  <v-layout column >
      <v-layout v-if="!creationLoaderDialog && !switchAccountDialog && !hasLocalTraining" column align-content-center
       fill-height>
        <v-flex xs12 mt-5 pt-5>
          <v-flex class="headline text-xs-center">Loading...</v-flex>
        </v-flex>
      </v-layout>

      <v-layout v-if="hasLocalTraining" row justify-center pa-2>
        <v-flex xs12 sm10 md8 lg6>
          <div class="wa-section pa-3">
            <p class="body-1 mb-2">Your location is in:</p>
            <div class="info-box mb-4">{{ locationName }}</div>

            <template v-if="trainingLinkLabel">
              <p class="body-1 mb-2">Local food handler training is required and available here:</p>
              <div class="info-box mb-4">
                <a v-if="trainingLink" :href="trainingLink" target="_blank" rel="noopener" class="training-link">
                  {{ trainingLinkLabel }}
                </a>
                <span v-else>{{ trainingLinkLabel }}</span>
              </div>
            </template>

            <my-certificates/>

            <p class="text-xs-center body-1 grey--text text--darken-2 mt-4 px-2">
              Upload your Food Worker Card or Food Protection Manager
              certificate here for safekeeping and compliance
            </p>
          </div>
        </v-flex>
      </v-layout>
    <v-dialog v-model="switchAccountDialog" persistent :width="$store.getters.getAppWidth - 10">
      <v-card>
        <v-toolbar dark color="primary" pr-0>
          <v-toolbar-title>Confirm Store ID</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn style="display:contents;"
                   dark flat @click="logout()"><span class="notranslate"><v-icon>close</v-icon></span></v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-flex>Hello again, {{userFullName}}!</v-flex>
          <store-verification :quick="true"/>
        </v-card-text>
        <v-card-text v-if="getUserDetails.store_details.storeId">
          <v-layout column>
            <v-flex px-4>
              <v-btn color="success" block @click="registerSfh">Confirm</v-btn>
            </v-flex>
            <v-flex mt-3 px-5 text-xs-center>
              <em>By confirming you accept the <a target="__blank" href="https://www.cogneti.com/terms-of-use">Cogneti License</a> terms.</em>
            </v-flex>
          </v-layout>

        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="creationLoaderDialog"
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please wait. Your account is being created...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
  import {mapGetters, mapMutations} from 'vuex'
  import crypto from '@/mixins/crypto'
  import StoreVerification from '../sign-up/62/StoreVerification.vue'
  import MyCertificates from '../auth/MyCertificates.vue'

  export default {
    name: 'Programs',
    components: {StoreVerification, MyCertificates},
    // components: {Header, ScrollData},
    data () {
      return {
        store: null,
        creationLoaderDialog: false,
        footer: false,
        courseId: process.env.GAME_ID,
        apiUrl: process.env.API_URL,
        switchAccountDialog: false,
        loading: true,
        registerLoading: true,
        email: localStorage.getItem('email') || null,
        userFullName: ''
      }
    },
    computed: {
      ...mapGetters('registration', ['getUserDetails']),
      ...mapGetters('user', ['hasLocalTraining', 'getLocalTraining']),
      locationName () {
        return this.getLocalTraining ? this.getLocalTraining.localName || '' : ''
      },
      trainingLink () {
        return this.getLocalTraining ? this.getLocalTraining.trainingLink || '' : ''
      },
      trainingLinkLabel () {
        return this.getLocalTraining ? this.getLocalTraining.trainingLinkLabel || '' : ''
      },
      groups: function () {
        return this.$store.getters['course/getGroups']
      },
      userId () {
        return this.user.id ? this.user.id : 0
      },
      user () {
        return this.$store.getters['user/getUserDetails']
      },
      currentGroup () {
        const filteredGroups = this.groups.reduce((a, b) => {
          const deck = b.decks.find(deck => deck.regId === this.courseId)
          if (deck) {
            return [...a, b]
          }
          return a
        }, [])
        return filteredGroups[0]
      }
    },
    mounted () {
      this.switchAccountDialog = false
      this.initPage()
    },
    methods: {
      ...mapMutations('registration', [
        'setUser'
      ]),
      registerSfh () {
        // COPY OF 52 GetNameAndPwd
        // const gameId = +process.env.GAME_ID
        this.creationLoaderDialog = true
        this.$store.commit('setLoadingDialog', true, { root: true })
        this.$http({
          url: process.env.API_URL + '/ws/userservice/splat/register',
          method: 'POST',
          data: {
            'firstName': null,
            'lastName': null,
            'password': null,
            'email': localStorage.getItem('email'),
            'client': null,
            'otpId': null,
            'country': null,
            'state': null,
            'app': null,
            'platform': null,
            'storeId': this.getUserDetails.store_details.storeId
          }
        }).then(() => {
          this.creationLoaderDialog = false
          this.switchAccountDialog = false
          this.$store.commit('setLoadingDialog', false, { root: true })
          this.$store.commit('flashSuccess', 'Store ID updated successfully.')
          this.logout()
        }, error => {
          this.creationLoaderDialog = false
          this.$store.commit('setLoadingDialog', false, { root: true })
          this.$store.commit('flashError', error.message, { root: true })
          this.creationLoaderDialog = false
        }).catch(error => {
          this.creationLoaderDialog = false
          this.$store.commit('setLoadingDialog', false, { root: true })
          this.$store.commit('flashError', error.message, { root: true })
        })
      },
      logout () {
        this.$auth.logout({
          redirect: '/',
          makeRequest: false
        })
      },
      fetchLocalTraining (state) {
        return this.$http({
          url: `${process.env.API_URL}/ws/splat/state/${state}/local_training`,
          method: 'GET',
          headers: {
            Authorization: 'Bearer ' + this.$auth.token()
          }
        }).then(res => {
          if (res.data && (res.data.trainingLink || res.data.trainingLinkLabel)) {
            this.$store.commit('user/setLocalTraining', res.data)
            return true
          }
          this.$store.commit('user/setLocalTraining', null)
          return false
        }).catch(() => {
          this.$store.commit('user/setLocalTraining', null)
          return false
        })
      },
      initPage () {
        if (localStorage.getItem('email')) {
          // eslint-disable-next-line no-console
          // console.log('=>', this.$store.getters['user/getCourses'][this.courseId].license)
          this.$store.dispatch('registration/checkEmailExists', localStorage.getItem('email')).then(response => {
            const course = this.$store.getters['user/getCourses'][this.courseId]
            const licensed = course.license
            const stores = course.stores.length
            const store = course.stores[0]
            console.log({stores: this.$store.getters['user/getCourses']})
            console.log({'responseData': response.data})
            const showSwitchAccount = () => {
              if (response.data.userState === 1 || !stores) {
                this.switchAccountDialog = true
                this.loading = true
                this.userFullName = response.data.firstName + ' ' + response.data.lastName
                this.email = response.data.email
              }
            }
            // for non CA users
            if (licensed) {
              // do noting
            } else if (store && store.state) {
              this.store = store
              this.fetchLocalTraining(store.state).then(found => {
                if (!found) showSwitchAccount()
              })
            } else {
              showSwitchAccount()
            }
          })
        }

        const role = this.$store.getters['user/getCourses'][this.courseId].role
        const availableRoles = ['Region Manager',
          'District Manager',
          'Store',
          'Restaurant',
          'Restaurant Manager']

        if (availableRoles.includes(role)) {
          if (this.groups.length === 0) {
            this.initiateDashboard()
          } else {
            this.goToProgramLevel()
          }
        } else
        if (this.$store.getters['user/getCourses'][this.courseId].stores.length > 0) {
          if (this.groups.length === 0) {
            this.initiateDashboard()
          } else {
            this.goToProgramLevel()
          }
        }
      },
      goToProgramLevel () {
        const group = this.currentGroup
        if (group) {
          if (this.userId) {
            this.redirect(group)
            return true
          }
        } else {
          this.$store.dispatch('course/fetchAvailablePrograms')
          setTimeout(() => {
            window.location.refresh()
          }, 7000)
        }
      },

      isProgramDetailPage () {
        return this.groups.length === 1 || typeof this.$route.params.deckId !== 'undefined'
      },
      initiateDashboard () {
        if (this.groups.length === 0) {
          this.$store.dispatch('course/fetchAvailablePrograms')
        }
      },
      checkIfUserIsRegistered () {
        const group = this.currentGroup

        if (group) {
          if (this.userId) {
            this.redirect(group)
          }
        }
      },
      redirect (group) {
        const deckId = group.decks[0].id
        const groupId = group.groupId

        if (this.$route.query.page === 'certificate-home') {
          this.$router.push({name: 'ProgramLevels', params: {deckId, groupId}}).catch(() => {
          })
        } else {
          this.$store.dispatch('splatReport/fetchStoresApi').then(({data}) => {
            this.$store.commit('splatReport/setStores', data || [])
            if (data && data.length > 0) {
              // Stores present: user manages one or more stores, land on Manager Actions
              this.$router.push({name: 'ManagerActions'}).catch(() => {
              })
            } else {
              // No stores: stay on the Food Handler home (certificate levels)
              this.$router.push({name: 'ProgramLevels', params: {deckId, groupId}}).catch(() => {
              })
            }
          })
        }
      }
      // completeProfile () {
      //   const data = {
      //     'first_name': this.user.firstName,
      //     'last_name': this.user.lastName,
      //     'name_verified': false,
      //     'email': this.encryptData(this.user.email),
      //     'email_verified': true,
      //     'email_otp_generated': false,
      //     'country': this.user.countryId,
      //     'state': this.user.stateId,
      //     'profile_image': this.apiUrl + this.user.userImageUrl
      //   }
      //   this.setUser({...this.getUserDetails, ...data})
      //   const group1 = this.groups.find(group => group.decks[0].regId === 52)
      //   // eslint-disable-next-line no-console
      //   console.log('GROUP', group1)
      //   // IT is for RCA to SFH ONLY
      //   if (!group1) {
      //     this.$router.push({name: 'SignUp', params: {step: 'get-name-and-pwd', email: this.encryptData(this.user.email)}})
      //   }
      // }
    },
    watch: {
      userId (val) {
        if (val) {
          this.initPage()
        }
      },
      groups () {
        if (this.groups.length > 0) {
          this.checkIfUserIsRegistered()
        }
      }
    },
    mixins: [crypto]
  }
  </script>

<style scoped>
  .wa-section {
    max-width: 560px;
    margin: 0 auto;
  }
  .info-box {
    background-color: #f2f2f2;
    border-radius: 4px;
    padding: 12px 14px;
    font-size: 15px;
    color: #333;
  }
  .training-link {
    color: #1976d2;
    text-decoration: underline;
    word-break: break-word;
  }
</style>




// WEBPACK FOOTER //
// src/components/views/Programs/Programs62.vue